import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {AbstractControl, FormControl, FormGroup} from '@angular/forms';
import {IdName} from "../../common-interfaces";

@Component({
    selector: 'app-multi-select-input',
    templateUrl: './multi-select-input.component.html',
    styleUrls: ['./multi-select-input.component.scss'],
    standalone: false
})
export class MultiSelectInputComponent {

  searchControl = new FormControl();

  @ViewChild('search') searchTextBox: ElementRef;

  @Input() label: any;

  @Input() formCtrlName: string;

  @Input() id: string;

  @Input() parentFormGroup: FormGroup;

  @Input() itemsSelectControl: AbstractControl;

  @Input() formatItemName: (itemName: string) => string;

  _items: IdName[] = [];
  get items(): IdName[] {
    return this._items;
  }
  @Input() set items(value: IdName[]) {
    this._items = value;
    this.setUpItems();
  }

  filteredItems: IdName[] = [];

  selectedItemIds = [];

  formatNameForItem(itemId: number) {
    let itemName =  this.items?.find(item => item.id === itemId)?.name;

    if(itemName == undefined)
      return itemName;

    if (this.formatItemName) {
      return this.formatItemName(itemName);
    } else {
      return itemName;
    }
  }

  selectOpened(e) {
    this.searchControl.patchValue('');
    // Focus to search textbox while clicking on selectbox
    if (e == true) {
      this.searchTextBox.nativeElement.focus();
    }
  }

  clearSearch(event) {
    event.stopPropagation();
    this.searchControl.patchValue('');
  }

  itemSelectionChange(event) {
    if (event.isUserInput && event.source.selected == false) {
      let index = this.selectedItemIds.indexOf(event.source.value);
      this.selectedItemIds.splice(index, 1)
    }
  }

  clearItems() {
    this.itemsSelectControl.patchValue(null);

    this.filteredItems = this.items;
    this.selectedItemIds = []
    this.storeSelectedItemIds()
  }

  storeSelectedItemIds() {
    if (this.itemsSelectControl && this.itemsSelectControl.value && this.itemsSelectControl.value.length > 0) {
      this.itemsSelectControl.value.forEach((e) => {
        if (this.selectedItemIds.indexOf(e) == -1) {
          this.selectedItemIds?.push(e);
        }
      });
    }

    if (this.selectedItemIds && this.selectedItemIds.length > 0) {
      this.itemsSelectControl.patchValue(this.selectedItemIds);
    }
  }

  private setUpItems() {
    this.setUpSelectedItems();
    this.searchControl.valueChanges.subscribe((value) => {
      this.storeSelectedItemIds();
      this.filteredItems = this.items.filter((user) => user.name.toLowerCase().includes(value.toLowerCase()))
      this.filteredItems = this.sortItemsBasedOnSelection();
    })
  }

  private setUpSelectedItems() {
    this.storeSelectedItemIds();
    this.filteredItems = this.items;
    this.filteredItems = this.sortItemsBasedOnSelection();
  }

  private sortItemsBasedOnSelection() {
    const checkedItems = this.filteredItems.filter(item => this.selectedItemIds.includes(item.id)).sort((item1, item2) => item1.name.localeCompare(item2.name));
    const uncheckedItems = this.filteredItems.filter(item => !this.selectedItemIds.includes(item.id)).sort((item1, item2) => item1.name.localeCompare(item2.name));;
    return [...checkedItems, ...uncheckedItems];
  }
}


